import { BaSeLoading } from '@base/react';
import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { useIsModuleRoute } from '../helpers/module-route';
import { HeaderMenuItem } from '@base/react/build/components/header/header';
import { MENU_ITEMS, USERS_MENU_ITEM } from '../models/header-model';
import { useGestaoAmeiService } from '../services/gestao-amei-service';

export const useHeader = () => {
  const { hasRoles } = Sebrae.useAuth();
  const { navigateTo } = Sebrae.useRouter();

  const menuConfig = React.useMemo(
    () => MENU_ITEMS.filter((item) => hasRoles(item.roles)),
    [hasRoles],
  );

  const { isModuleRoute } = useIsModuleRoute();

  const { gestaoAmeiUrl, gestaoAmeiUrlLoading } = useGestaoAmeiService();

  const canSeeUsersItem = React.useMemo(
    () => hasRoles([...USERS_MENU_ITEM.roles]),
    [hasRoles],
  );

  const menuItems: HeaderMenuItem[] = React.useMemo(() => {
    const items: HeaderMenuItem[] = menuConfig.map(
      ({ label, to, routePaths }) => ({
        label,
        onClick: () => navigateTo(to),
        isActive: isModuleRoute(routePaths),
      }),
    );

    if (!canSeeUsersItem) {
      return items;
    }

    if (gestaoAmeiUrlLoading) {
      items.push({
        component: () => <BaSeLoading spinnerSize={16} />,
        isActive: false,
      });
      return items;
    }

    if (gestaoAmeiUrl) {
      items.push({
        label: USERS_MENU_ITEM.label,
        onClick: () =>
          window.open(gestaoAmeiUrl, '_blank', 'noopener,noreferrer'),
        isActive: false,
      });
    }

    return items;
  }, [
    isModuleRoute,
    menuConfig,
    navigateTo,
    canSeeUsersItem,
    gestaoAmeiUrl,
    gestaoAmeiUrlLoading,
  ]);

  return {
    menuConfig,
    menuItems,
  };
};
